import React from "react";
import classNames from "classnames";

const borderColor = {
  disabled: "brand-grey-200",
  enabled: "brand-grey-400",
};

const Button = (props) => {
  const { content, marginRight, disabled, handleOnClick, active } = props;

  const diabledClass = classNames({
    "border-brand-grey-200": disabled,
    "text-brand-grey-400": disabled,
    "cursor-not-allowed": disabled,
    border: disabled,
  });

  const activeClass = classNames({
    "border-brand-grey-400": !active,
    "border-brand-green-500": active,
    "text-brand-green-500": active,
    "text-brand-grey-800": !active,
    "hover:border-brand-green-500": !active,
    "hover:text-brand-green-500": !active,
    border: !active,
    "border-2": active,
  });

  return (
    <button
      type="button"
      style={{ marginRight: marginRight }}
      className={`px-6 py-3 font-500 font-16 leading-6 rounded-lg 
      ${disabled ? diabledClass : activeClass}
      `}
      onClick={() => {
        handleOnClick();
      }}
    >
      {content}
    </button>
  );
};

export default Button;
